import React, { FC } from 'react';
import { Alert, AlertTitle, Box } from '@mui/material';

interface AlertMessageProps {
  severity?: 'error' | 'success' | 'info' | 'warning';
  error?: string | null;
  clearError?: () => void;
}

const AlertMessage: FC<AlertMessageProps> = ({ severity = 'error', error, clearError }: AlertMessageProps) => {
  if (!error) {
    return null;
  }

  return (
    <Box
      sx={{
        width: '100%',
        '& > * + *': {
          mt: 2,
        },
        mt: 'var(--space-stack-relaxed)',
        mb: 'var(--space-stack-relaxed)',
      }}
    >
      <Alert severity={severity} onClose={clearError}>
        <AlertTitle>Error</AlertTitle>
        {error}
      </Alert>
    </Box>
  );
};

export default AlertMessage;
